import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Calculator from './components/Calculator';
import About from './components/About';
import Services from './components/Services';
import Network from './components/Network';
import WhyUs from './components/WhyUs';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';

function App() {
  return (
    <div className="font-sans antialiased text-brand-black bg-white overflow-x-hidden selection:bg-brand-red selection:text-white">
      <Navbar />
      <main>
        <Hero />
        <Calculator />
        <About />
        <Services />
        <Network />
        <WhyUs />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;